/**
 * Proposal Type Registry — single source of truth for proposal-type → slide-deck mapping.
 *
 * Adding a new proposal type:
 *   1. Build a slide registry + render function in your slides module
 *   2. Register it here
 *   3. The backend already validates `type ∈ PROPOSAL_TYPES` (`backend/routes/proposals.py`)
 *
 * The optional `slidesFor(payload)` hook lets a deck return a payload-specific
 * slide list (e.g. consolidation hides the Lender Options slide when the
 * broker didn't attach any lenders).
 */
import { CONSOLIDATION_SLIDES, renderSlide as renderConsolidationSlide, slidesFor as consolidationSlidesFor } from './ConsolidationSlides';
import { BROKER_PROPOSAL_SLIDES, renderBrokerProposalSlide } from './BrokerProposalSlides';
import { UPLOADED_PDF_SLIDES, renderSlide as renderUploadedPdfSlide, slidesFor as uploadedPdfSlidesFor } from './UploadedPdfSlides';

export const PROPOSAL_REGISTRY = {
  consolidation: {
    label: 'Debt Consolidation',
    slides: CONSOLIDATION_SLIDES,
    slidesFor: consolidationSlidesFor,
    render: renderConsolidationSlide,
  },
  purchase: {
    label: 'Purchase Proposal',
    slides: BROKER_PROPOSAL_SLIDES,
    render: renderBrokerProposalSlide,
  },
  refinance: {
    label: 'Standard Refinance',
    slides: BROKER_PROPOSAL_SLIDES,
    render: renderBrokerProposalSlide,
  },
  uploaded_pdf: {
    label: 'Uploaded PDF Proposal',
    slides: UPLOADED_PDF_SLIDES,
    slidesFor: uploadedPdfSlidesFor,
    render: renderUploadedPdfSlide,
  },
};

export const getProposalEntry = (type) => PROPOSAL_REGISTRY[type] || PROPOSAL_REGISTRY.consolidation;

/** Slide list for a SPECIFIC payload. Falls back to the static `slides` array
 *  if the deck didn't supply a `slidesFor` resolver. */
export const slidesForProposal = (type, payload) => {
  const entry = getProposalEntry(type);
  return entry.slidesFor ? entry.slidesFor(payload) : entry.slides;
};

export default PROPOSAL_REGISTRY;
